import { render } from "./Final.vue?vue&type=template&id=3681ea0a"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"
script.render = render

export default script